import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLocation, useNavigate } from "react-router-dom";
const CustomMenu = ({
  mobile = false,
  items,
  uniqueKey,
  depthLevel,
  onHandleToggle,
  inBar = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdown, setDropdown] = useState(false);
  let ref = useRef();
  const isActive =
    location.pathname === items.link ||
    location.pathname.startsWith(`${items.link}/`);
  const linkClass = [
    depthLevel > 0 ? "action-link-submenu" : "action-link",
    inBar && depthLevel === 0 ? "header-cat-link" : "",
    inBar && depthLevel === 0 && isActive ? "header-cat-link-active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  useEffect(() => {
    if (mobile) {
      return undefined;
    }
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown, mobile]);

  const onMouseEnter = () => {
    window.innerWidth > 599 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 599 && setDropdown(false);
  };

  const desktopChevron =
    !mobile && inBar && items.submenu.length > 0 ? (
      <KeyboardArrowDownIcon
        className="header-cat-chevron"
        sx={{
          fontSize: 16,
          ml: 0.15,
          transform: dropdown ? "rotate(180deg)" : "none",
          transition: "transform 0.2s ease",
        }}
      />
    ) : (
      <></>
    );

  const renderLabel = () => {
    if (!mobile) {
      return <Typography variant="body1">{items.title}</Typography>;
    }

    const avatarSize = depthLevel > 0 ? 26 : 32;
    return (
      <Box
        className="menu-item-content"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          minWidth: 0,
          flex: 1,
          textAlign: "left",
        }}
      >
        <Avatar
          src={items.imageUrl || undefined}
          alt={items.title}
          className="menu-item-avatar"
          sx={{
            width: avatarSize,
            height: avatarSize,
            fontSize: depthLevel > 0 ? "0.72rem" : "0.82rem",
            fontWeight: 700,
            bgcolor:
              depthLevel > 0
                ? "rgba(7, 94, 84, 0.06)"
                : "rgba(7, 94, 84, 0.08)",
            color: "#075e54",
            border: "1px solid rgba(7, 94, 84, 0.12)",
            flexShrink: 0,
            "& img": {
              objectFit: "cover",
              width: "100%",
              height: "100%",
            },
          }}
        >
          {items.title ? items.title.charAt(0).toUpperCase() : null}
        </Avatar>
        <Typography variant="body1">{items.title}</Typography>
      </Box>
    );
  };

  return (
    <ul className="menu-ul" key={uniqueKey}>
      <li
        key={uniqueKey}
        className={`menu-items${mobile ? "-mobile" : ""}`}
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {items.submenu.length > 0 ? (
          <>
            <Button
              className={linkClass}
              onClick={() => {
                setDropdown((prev) => !prev);
                !mobile && navigate(items.link);
              }}
              aria-expanded={mobile ? dropdown : undefined}
              endIcon={
                mobile && items.submenu.length > 0 ? (
                  <KeyboardArrowDownIcon
                    className={`site-drawer-chevron${dropdown ? " is-open" : ""}`}
                    fontSize="small"
                  />
                ) : (
                  desktopChevron
                )
              }
            >
              {renderLabel()}
            </Button>
            <Dropdown
              mobile={mobile}
              depthLevel={depthLevel}
              submenus={items.submenu}
              dropdown={dropdown}
              onHandleToggle={onHandleToggle}
            />
          </>
        ) : (
          <Button
            fullWidth={true}
            className={linkClass}
            onClick={() => {
              setDropdown((prev) => !prev);
              mobile && onHandleToggle();
              navigate(items.link);
            }}
          >
            {renderLabel()}
          </Button>
        )}
      </li>
    </ul>
  );
};

export default CustomMenu;
